export default function EmailModalHelp({ setShowHelpModal }) {

    const handleRemoveModalHelp = () => {
        setShowHelpModal(false)
    };

    return (
        <form>
            <fieldset>
                <legend>Aide pour les variables</legend>
                <h4>Liste des variables desquelles vous servir pour personnaliser vos emails.</h4>
                <div className="flex-help-modal">
                    <ul>
                        <li><span>Demande de type :</span> {"{{message.requestTypeLabel}}"}</li>
                        <li><span>reçu le :</span> {"{{message.createdAt|date('d/m/Y H:i')}}"}</li>
                        <li><span>Agence émettrice :</span> {"{{message.agencyName}}"}</li>
                        <li><span>ID :</span> {"{{message.agencyId}}"}</li>
                    </ul>
                    <ul>
                        <h4>Informations du demandeur</h4>
                        <li><span>Civilité :</span> {"{{message.civility}}"}</li>
                        <li><span>Nom & prénom :</span> {"{{message.fullname|upper}}"}</li>
                        <li><span>Date de naissance :</span> {"{{message.prospectAge|date('d/m/Y')}}"}</li>
                        <li><span>Email :</span> {"{{message.prospectEmail}}"}</li>
                        <li><span>Téléphone :</span> {"{{message.prospectPhone}}"}</li>
                        <li><span>Code Postal :</span> {"{{message.companyZipcode}}"}</li>
                        <li><span>Ville :</span> {"{{message.companyTown}}"}</li>
                        <li><span>IP Client :</span> {"{{message.prospectIp}}"}</li>
                        <li><span>Commentaire :</span> {"{{message.message}}"}</li>
                    </ul>
                    <ul>
                        <h4>Informations concernant le décès</h4>
                        <li><span>Date du décès :</span> {"{{message.deathDate|date('d/m/Y')}}"}</li>
                        <li><span>Lieu de décès :</span> {"{{message.deceasedPlace}}"}</li>
                        <li><span>Lieu de fin de vie :</span> {"{{message.deceasedPlace}}"}</li>
                        <li><span>Code postal :</span> {"{{message.deathZipCode}}"}</li>
                        <li><span>Ville :</span> {"{{message.deathCity}}"}</li>
                    </ul>
                    <ul>
                        <h4>Informations concernant la demande</h4>
                        <li><span>Montant du capital :</span> {"{{message.quotationAmount}}"}</li>
                        <li><span>Durée souhaitée :</span> {"{{message.quotationDuration}}"}</li>
                        <li><span>Nom de l'entreprise :</span> {"{{message.companyName}}"}</li>
                        <li><span>Type d'obsèques :</span> {"{{message.funeralChoicesA}}"}</li>
                        <li>Informations concernant la demande</li>
                        <li><span>Code postal :</span> {"{{message.cemeteryZipCode}}"}</li>
                        <li><span>Ville :</span> {"{{message.cemeteryCity}}"}</li>
                    </ul>
                    <ul>
                        <li><h4>Informations complémentaires</h4></li>
                        <li><span>Lien de parenté avec le défunt :</span> {"{{message.familyLink}}"}</li>
                        <li><span>Type d'obsèques souhaité :</span> {"{{message.funeralChoices|join(', ')}}"}</li>
                        <li><span>Type de cérémonie souhaité :</span> {"{{message.ceremonyTypeLabel}}"}</li>
                        <li><span>Code postal de la cérémonie :</span> {"{{message.funeralZipCode}}"}</li>
                        <li><span>Ville de la cérémonie :</span> {"{{message.funeralCity}}"}</li>
                        <li><span>Y a-t-il une concession existante ?</span> {"{{message.cemeteryConcession}}"}</li>
                        <li><span>Y a-t-il un caveau ?</span> {"{{message.cemeteryVault}}"}</li>
                        <li><span>Y a-t-il un monument ?</span> {"{{message.cemeteryMonument}}"}</li>
                        <li><span>Agences choisies :</span> {"{{agency.name}}"}</li>
                        <li><span>Nombre d'agences :</span> {"{{message.agencyNumber}}"}</li>
                        <li><span>Propriétaire d'un funérarium :</span> {"{ % if message.funerariumOwner == '1' %}Oui{% else %}Non{% endif %}"}</li>
                        <li><span>Groupement :</span> {"{ % if message.hasGroup == '1' %}Oui{% else %}Non{% endif %}"}</li>
                        <li><span>Nom du groupement :</span> {"{{message.groupName}}"}</li>
                    </ul>
                    <ul>
                        <li><span>Nom de l'entreprise :</span> {"{{message.companyName}}"}</li>
                        <li><span>Adresse Postale :</span> {"{{message.companyAddress}}"}</li>
                        <li><span>Site Internet :</span> {"{{message.website}}"}</li>
                        <li><span>Code Postal :</span> {"{{message.companyZipcode}}"}</li>
                        <li><span>Ville :</span> {"{{message.companyTown}}"}</li>
                        <li><span>Nom du responsable :</span> {"{{message.lastName}}"}</li>
                        <li><span>Prénom du responsable :</span> {"{{message.firstName}}"}</li>
                        <li><span>E-mail du responsable :</span> {"{{message.email}}"}</li>
                        <li><span>Téléphone :</span> {"{{message.telephone}}"}</li>
                        <li><span>Mobile :</span> {"{{message.mobile}}"}</li>
                        <li><span>Fonction :</span> {"{{message.fonction}}"}</li>
                        <li><span>Demande :</span> {"{{message.proposition}}"}</li>
                        <li><span>IP :</span> {"{{message.prospectIp}}"}</li>
                        <li><span>Autres activités :</span> {"{{message.otherActivities}}"}</li>
                    </ul>
                </div>
            <div className="flex">
                <button type="button" onClick={(e) => handleRemoveModalHelp(e)}><i className="fa fa-arrow-down"/><span>Cacher</span></button>
            </div>
            </fieldset>
        </form>
    )
}